var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9484_16676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 30.9998C24.2841 30.9998 30.9998 24.2841 30.9998 15.9999C30.9998 7.71569 24.2841 1 15.9999 1C7.71569 1 1 7.71569 1 15.9999C1 24.2841 7.71569 30.9998 15.9999 30.9998Z",
    fill: "white",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 27.2499C22.2131 27.2499 27.2499 22.2131 27.2499 15.9999C27.2499 9.78677 22.2131 4.75 15.9999 4.75C9.78677 4.75 4.75 9.78677 4.75 15.9999C4.75 22.2131 9.78677 27.2499 15.9999 27.2499Z",
    fill: "white",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 23.4999C20.1421 23.4999 23.4999 20.1421 23.4999 16C23.4999 11.8578 20.1421 8.5 16 8.5C11.8578 8.5 8.5 11.8578 8.5 16C8.5 20.1421 11.8578 23.4999 16 23.4999Z",
    fill: "white",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.75C18.071 19.75 19.75 18.071 19.75 16C19.75 13.9289 18.071 12.25 16 12.25C13.9289 12.25 12.25 13.9289 12.25 16C12.25 18.071 13.9289 19.75 16 19.75Z",
    fill: "white",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 1V30.9998V1ZM26.568 26.568L5.43179 5.43179L26.568 26.568ZM26.568 5.43179L5.43179 26.568L26.568 5.43179ZM30.9998 15.9999H1H30.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 1V30.9998M26.568 26.568L5.43179 5.43179M26.568 5.43179L5.43179 26.568M30.9998 15.9999H1",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 15.9983H19.2C19.2414 15.7034 19.2414 15.4042 19.2 15.1094L16 15.9983Z",
    fill: "#4444CC",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.0003L22.0444 8.35582C21.2346 7.7464 20.335 7.2666 19.3778 6.93359L16 16.0003Z",
    fill: "#BBCC33",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 15.9992L13.1556 3.19922C11.1345 3.64233 9.24629 4.55595 7.64453 5.86589L16.0001 15.9992Z",
    fill: "#DD9933",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 15.9973L5.68837 11.0195C4.68341 13.1835 4.37291 15.6054 4.79949 17.9529L15.9995 15.9973Z",
    fill: "#DDBB33",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 16L10.1328 18.8444C10.2296 19.149 10.3484 19.4461 10.4884 19.7333L15.9995 16Z",
    fill: "#33BBBB",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 16L14.2227 24C15.2789 24.2107 16.3664 24.2107 17.4227 24L16.0004 16Z",
    fill: "#33CC99",
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16L24.1778 26.3111C24.9683 25.6842 25.6842 24.9683 26.3111 24.1778L16 16Z",
    fill: "#DD7733",
    stroke: "#808080"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9484_16676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo17);
export default __webpack_public_path__ + "static/media/logo17.c8097bcc354859b39c43d007ed7190bb.svg";
export { ForwardRef as ReactComponent };